import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const gapi = axios.create({ baseURL: `${BACKEND}/api/g`, withCredentials: true, headers: { "X-CG-Request": "1" } });

export const backendUrl = (p) => `${BACKEND}${p}`;

export function errMsg(e, fallback = "Operazione non riuscita") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
}

const TZ = "Europe/Rome";
export const fmtDateTime = (iso) =>
  !iso ? "—" : new Intl.DateTimeFormat("it-IT", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
export const fmtDate = (iso) =>
  !iso ? "—" : new Intl.DateTimeFormat("it-IT", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(iso));
export const fmtEuro = (n) =>
  n == null || n === "" ? "dato non disponibile" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export const AZIONI_LABEL = {
  visualizzare: "Vedere", creare: "Creare", modificare: "Modificare", archiviare: "Archiviare", esportare: "Esportare", pubblicare: "Pubblicare",
};

export const AUDIT_LABEL = {
  accesso: "Accesso", uscita: "Uscita", accesso_fallito: "Accesso fallito", accesso_negato: "Accesso negato",
  verifica_2fa_fallita: "Codice 2FA errato", codice_recupero_usato: "Codice di recupero usato",
  attivazione_titolare: "Attivazione titolare", richiesta_attivazione_titolare: "Richiesta attivazione titolare",
  invito_creato: "Invito creato", invito_revocato: "Invito revocato", invito_accettato: "Invito accettato",
  utente_modificato: "Utente modificato", utente_disattivato: "Utente disattivato", utente_riattivato: "Utente riattivato",
  sessioni_revocate: "Sessioni revocate", sessione_revocata: "Sessione revocata", riassegnazione: "Riassegnazione",
  permessi_modificati: "Permessi modificati", richiesta_reset_password: "Richiesta reset password",
  password_reimpostata: "Password reimpostata", password_cambiata: "Password cambiata",
  codici_recupero_rigenerati: "Codici di recupero rigenerati", file_caricato: "File caricato", file_scaricato: "File scaricato",
  file_scaricato_link: "File scaricato (link temporaneo)", link_temporaneo_creato: "Link temporaneo creato",
  backup_creato: "Backup creato", backup_scaricato: "Backup scaricato",
};
